import { query } from '../utilities';

export const geoCitySelect = (name, fiasId) => {
    return query('/geo/city/select/', {
        data: { name, fiasId }
    });
};
